
<template>
  <div class="wrap talk re-style">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <template v-if="isWaitData">
          <div class="wrap talk">
            <header><h1><a class="logo"></a></h1></header>
            <div class="container">
              <main class="content">
                <article class="certification">
                  <section class="txt return">
                    <p class="return-txt">
                      주문 정보 확인중입니다
                      <br />
                    </p>
                  </section>
                </article>
              </main>
            </div>
          </div>
        </template> 
        <template v-if="isInqueryData">
          <section>
            <div>
              <Header />
              <PrchModelInfo :ordInfo="ordInfo" :isRegDone="isRegDone" @changeDonate="changeDonate" @changeAllDonate="changeAllDonate"/>
              <NewBankHeader
                :ordInfo="ordInfo"
                :bankCdList="bankCdList"
                :isRegDone="isRegDone"
                :temp_om_account="temp_om_account"
                :isPassYn="isPassYn"
                :isForeigner="isForeigner"
                :orgCstmNm="orgCstmNm"
                @changeBankInfo="newVal => params = newVal"
                @certPass="certPass"
              />
              <NewBankInfo v-if="!isAllDonate"
                :ordInfo="ordInfo"
                :bankCdList="bankCdList"
                :isRegDone="isRegDone"
                :temp_om_account="temp_om_account"
                :isPassYn="isPassYn"
                :isForeigner="isForeigner"
                :orgCstmNm="orgCstmNm"
                @changeBankInfo="newVal => params = newVal"
                @certPass="certPass"
                @validation="validation"
              />
              <EventInfo
                :isRegDone="isRegDone"
                :isEvent="isEvent"
                :temp_event="temp_event"
                :ordNum="getOrderNumber"
                @changeEventInfo="newVal => eventVal = newVal"
                @changeCheckedValue="newVal => isEventChecked = newVal"
                @changeEventAmt="newVal => ordInfo.eventAmt = newVal"
                @validation4="validation4"
              />
              <Donate v-if="isDonate" 
              	:ordInfo="ordInfo"
                :bankCdList="bankCdList"
                :isRegDone="isRegDone"
                :temp_om_account="temp_om_account"
                :isPassYn="isPassYn"
                :isForeigner="isForeigner"
                :orgCstmNm="orgCstmNm"
                @changeDntnInfo="newVal => dntnParams = newVal"
                @validation2="validation2"
                @validation3="validation3"
              />
              <Terms :isO2o="isO2o" :ordInfo="ordInfo" :isRegDone="isRegDone" :isDonate="isDonate" :isEtland="isEtland" @aggreAllAgrm="newVal => agrms = newVal"/>
              <HomeTerms v-if="isO2o" :isO2o="isO2o" :ordInfo="ordInfo" :isRegDone="isRegDone" @aggreAllAgrm="newVal => agrms = newVal"/>
            </div>
          </section>
          <div v-if="!isRegDone" id="regBtnDiv" class="ui-buttons">
            <ul class="ui-buttons__list">
              <li class="ui-buttons__item">
                <button
                  type="button"
                  class="ui-button ui-basic-button"
                  @click="handleEnrollmentButtnClick"
                >
                  등록하기
                </button>
              </li>
            </ul>
          </div>
        </template>
        <template v-if="isNotData">
          <div class="wrap talk">
            <header><h1><a class="logo"></a></h1></header>
            <div class="container">
              <main class="content">
                <article class="certification">
                  <section class="txt return">
                    <p class="return-txt">
                      주문 정보를 확인하지 못했습니다
                      <br />
                      잠시 후 다시 시도해 주세요
                      <br />
                      또는
                      <span>
                        <a href="tel: 1877-5446">
                          고객센터
                        </a>
                      </span>
                      에 문의 바랍니다
                    </p>
                  </section>
                </article>
              </main>
            </div>
          </div>
        </template> 
        <div class="cs-center row row_ac row_jsc">
          <span class="qa">고객센터 문의 </span>
          <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>

import Header from './components/Header.vue'
import PrchModelInfo from './components/NewPrchModlInfo.vue' // 250519 수정
import BankInfo from './components/BankInfo.vue'
import NewBankHeader from './components/NewBankHeader.vue'
import NewBankInfo from './components/NewBankInfo.vue'
import EventInfo from './components/EventInfo.vue' 
import Donate from './components/NewDonate.vue' //250520 추가
import Terms from './components/NewTerms.vue'  // 250519 수정
import HomeTerms from '../home/components/NewTermsHome.vue'  // 250519 수정
import DxValidationGroup from 'devextreme-vue/validation-group'
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'

import utils from '@/modules/utils'

export default {
  name: 'TalkDepositNew',
  components: {
    Header,
    PrchModelInfo,
    BankInfo,
    Terms,
    Donate,
    EventInfo,
    NewBankInfo,
    NewBankHeader,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup,
    HomeTerms
  },
  data: () => ({
    isRegDone: false,
    isPassYn: 'N',
    isForeigner: false,
    isEvent: false,
    isWaitData: true,
    isInqueryData: false,
    isNotData: false,
    isShowDetail: true,
    isEventChecked: false,
    agrms: {
    	allAgrm: false,
    	etlandAgrm:false,
    	dntnAgrm:false,
    	dntnAgrm2:false,
    	chocAgrm:false
    },
    bankCdList: [],
    temp_om_account: '',
    temp_event: '',
    eventVal: '',
    orgCstmNm: '',
    valid: null,
    valid2: null,
    valid3: null,
    txtBox: null,
    txtBox2: null,
    txtBox3: null,
    txtBox4: null,
    txtBox5: null,
    params: {
      cstmNm: '',
      bankCd: '',
      cstmAccnNum: null
    },
    partDntnAmt: 0,
    dntnParams: {
    	dntnCstmNm: '',
    	dntnCstmIdntNum: ''
    },
    donateResponse: {
        SUCCESS: "등록되었습니다",
        INVAILD_NUMBER: "주민번호가 유효하지 않습니다",
        NOT_AGREE: "필수사항에 모두 동의하셔야 기부하실수 있습니다",
        EXIST: "이미 기부 신청 되었습니다",
        FAIL: "기부신청시 오류가 발생하였습니다",
      },
    isDonate: false,
    isAllDonate: false,
    certParams:{
      pass_type: '4',
      cstmClphNum: '',
      ordNumber: ''
    },
    ordInfo: {
      corporationCode: '',
      cstmNm: '',
      cstmClphNum: '',
      orderModel: '',
      payAddCmpAmt: '',
      proNum: '',
      ptnmNm: '',
      totPymtAmt: '',
      dntnCstmNm: '',
      eventAmt:'0',
      dntnCstmIdntNum: '',
      partDntnAmt:'',
      cate02Num:0
    },
    eventAmt:'0',
    isO2o:false,
    isEtland:false
  }),
  computed: {
    isFormDone () {
      const { params } = this
      return Object.keys(params).filter(key => params[key]).length === Object.keys(params).length
    },
    isDntnDone () {
      if(this.dntnParams.dntnCstmNm == '무기명') {
      	return true
      }
      const { dntnParams } = this
      return Object.keys(dntnParams).filter(key => dntnParams[key]).length === Object.keys(dntnParams).length
    },
    isEnable () {
    // allAgrm 개인정보동의 , dntnAgrm 고유식별번호 동의 , this.isFormDone 계좌항목 빠진거있는지 , isDntnDone 기부자정보 빼먹은거 없는지
      if(this.isAllDonate && this.dntnParams.dntnCstmNm != '무기명') {  
      	return this.agrms.allAgrm && this.agrms.dntnAgrm && this.agrms.dntnAgrm2 && this.isDntnDone
      } else if(this.isDonate && this.dntnParams.dntnCstmNm != '무기명') {
      	return this.agrms.allAgrm && this.agrms.dntnAgrm && this.agrms.dntnAgrm2 && this.isDntnDone && this.isFormDone
      } else if(this.isAllDonate  && this.dntnParams.dntnCstmNm == '무기명') {  
      	return this.agrms.allAgrm && this.isDntnDone
      } else if(this.isDonate  && this.dntnParams.dntnCstmNm == '무기명') {
      	return this.agrms.allAgrm && this.isDntnDone && this.isFormDone 
      } else {
      	return this.agrms.allAgrm && this.isFormDone 
      }
    },
    getOrderNumber () {
      return this.$route.query.ord_number
    },
    getPassYn () {
      return this.$route.query.passYn
    },
    isPrePaymentOrder () {
      return this.ordInfo.corporationCode === '020200'
    }
  },
  created () {
    this.getCommCodeByBankCd()
  },
  mounted () {
    const passYn = this.getPassYn
    this.isPassYn=passYn
    if ("Y" === passYn) {
      this.$Alert.alert('PASS 인증이 성공했습니다')
      this.isForeigner = true
    } else if ("N" === passYn) {
      this.$Alert.alert('PASS 인증이 실패했습니다. 잠시 후 다시 시도해 주시기 바랍니다')
      this.isForeigner = true
    }
    
      this.getOrderInfo()
  },
  watch: {
    temp_om_account (newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /[^0-9]/g
        const result = `${newVal}`.replace(regex, '')
        this.temp_om_account = result
        this.params.cstmAccnNum = result
      }
    },
    temp_event (newVal, oldVal) {
        if (newVal !== oldVal) {
          const regex = /\s/g
          const result = `${newVal}`.replace(regex, '')
          this.temp_event = result
          this.params.eventVal = result
        }
      },
    isEnable (newVal) {
      if (document && newVal) {
        const regBtnDiv = document.getElementById('regBtnDiv')
        if (regBtnDiv) {
          const trgtHeight = regBtnDiv.offsetTop + 87
          window.scrollTo(0, trgtHeight)
        }
      }
    }
  },
  methods: {
	async getCommCodeByBankCd () {
      const params = {cmnsCdGrpId: 'BANK_CD'}
      const response = await this.$http.get('/api/appmgmt/public/common/code/list', {params})
      const codeList = []
      if (response && response.data && response.data.result) {
        response.data.result.forEach(c => {
          codeList.push({
            cmnsCd: c.cmnsCd,
            cmnsCdNm: c.cmnsCdNm
          })
        })
      }
      this.bankCdList = [...codeList]
    },
    async getOrderInfo () {
      const res = await this.$http.get(`/api/purchase/public/bank/getOrderInfo/${this.getOrderNumber}`)

      if (res) {
        const { data: { status, result } } = res
        if (status === '200' && result) {
          this.isInqueryData = true
          this.isWaitData = false
          const { corporationCode, totPymtAmt, bankCd, cstmBankNm, decCstmAccnNum, cstmNm, pgrpCd, eventCode , sgstCtts, cstmClphNum, isO2o,
           partDntnAmt, dntnCstmNm,dntnCstmIdntNum, atmtTrntStatDvsn, isEtland, payAddCmpAmt , payAddCmpAmts , payAddCmpCtts
          } = result
          if(partDntnAmt > 0) {
           	this.isDonate = true
          }
          if(partDntnAmt == totPymtAmt) {
           	this.isAllDonate = true
          }
          this.isO2o = isO2o > 0 ? true : false;
          this.isEtland = isEtland > 0 ? true : false;
          this.temp_event = sgstCtts
          if(this.temp_event != '') {
          	this.isEventChecked = true
          }
          if ((bankCd && cstmBankNm && decCstmAccnNum && cstmNm) || dntnCstmNm) {
            this.isRegDone = true
            this.temp_om_account = decCstmAccnNum
           
            this.params = {
              cstmNm,
              bankCd
            }
            this.dntnParams = {
              dntnCstmNm,
              dntnCstmIdntNum
            }
          }
          if(atmtTrntStatDvsn == 'F') {
           	 this.isAllDonate = false
             this.isRegDone = false
          }
          this.orgCstmNm = cstmNm
          this.certParams.cstmClphNum = cstmClphNum
          this.isEvent = eventCode === '1'
          if(this.isO2o){
              this.agrms.allAgrm = true
          }
          const isPhone = pgrpCd === '101'
          const isPrePaymentOrder = (corporationCode === '020200' || corporationCode === '020801')
          const prePaymentMsg = '계좌 입력 후 3분 이내 지급'
          const postPaymentMsg = '최종 판매 동의 시 입금'
          const postPymtAmtMsg = `검수 후 안내 예정<br />*검수가 완료되어 가격이 최종 확정되면 별도 알림톡을 보내드립니다`
          const eventAmt='0'
          this.ordInfo = {
            ...result,
            isPhone,
            eventAmt,
            depositMsg: this.isO2o ? '계좌입력 후 3분 이내 지급' : isPhone ? (isPrePaymentOrder ? prePaymentMsg : postPaymentMsg) : '최종 판매동의시 30분이내 지급',
            pymtAmtMsg: this.isO2o ? utils.numberComma(totPymtAmt) :  isPrePaymentOrder ? utils.numberComma(totPymtAmt) : postPymtAmtMsg,
            prchClsfName: isPhone ? '휴대폰 종류' : '판매제품'
          }
        } else {
          this.isNotData = true
          this.isWaitData = false
          this.$Alert.alert('주문 정보를 확인하지 못했습니다. 잠시 후 다시 시도해 주시기 바랍니다')
            .then(() => {
              this.closeWindow()
            })
        }
      }
    },
    closeWindow () {
      const ua = navigator.userAgent.toLowerCase()

      console.log('====> Close Calling!!! ')

      if (ua.indexOf('kakaotalk') > -1) {
        if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1) {
          window.location.href = 'kakaoweb://closeBrowser'
        } else {
          window.location.href = 'kakaotalk://inappbrowser/close'
        }
      } else if (window) {
        if (window.opener) {
          window.opener.close()
        }
        window.close()
      }
    },
    async handleEnrollmentButtnClick (e) {
      if(this.isAllDonate && !this.isDntnDone) {
      	if(!this.valid2.instance.validate().isValid) {
      		this.txtBox3.instance.focus()
      		return
      	}
      	if(!this.valid3.instance.validate().isValid) {
      		this.txtBox4.instance.focus()
      		return
      	}
      }

      if(this.isDonate && !this.isAllDonate) {
        if(!this.valid.instance.validate().isValid) {
        	if(this.valid.instance.validate().brokenRules[0].message.indexOf('이름') != -1) {
      		this.txtBox.instance.focus()
      		return
	      	} else {
	      		this.txtBox2.instance.focus()
	      		return
	      	}
        }
      	if(!this.valid2.instance.validate().isValid) {
      		this.txtBox3.instance.focus()
      		return
      	}
      	if(!this.valid3.instance.validate().isValid && !this.isDntnDone) {
      		this.txtBox4.instance.focus()
      		return
      	}
      }
      
      if(!this.isDonate && !this.valid.instance.validate().isValid) {
      	if(this.valid.instance.validate().brokenRules[0].message.indexOf('이름') != -1) {
      		this.txtBox.instance.focus()
      		return
      	} else {
      		this.txtBox2.instance.focus()
      		return
      	}	
      }
      
      let enableMsg = `
        <h3>필수 정보 입력 안내</h3>
        <div style="font-size: 14px; font-weight: 400; line-height:18px;">
          <br>이름과 입금계좌번호를 입력하고 <br>필수 약관에 동의해야
          <br>다음 단계로 진행할 수 있어요
        </div>
      `
      
      if (!this.isEnable) {
        this.$Alert.alert(enableMsg)
        return
      }
      
      if(this.dntnParams.dntnCstmNm != '무기명' && this.isDonate) {
      	const birth = this.dntnParams.dntnCstmIdntNum;
		  const regUnique = /^\d{2}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[01])[1-4]\d{6}$/;
		  
		  if(!regUnique.test(birth)) {
			  this.$Alert.alert('주민번호를 확인해주세요')
        	  return
		  }
      }
	
      if (this.eventVal && !this.isEventChecked) {
        let msg = `
                    <h3>이벤트 코드를 등록해 주세요!</h3>
                    <div style="font-size: 14px; font-weight: 400; line-height:18px; margin-bottom: 10px;">
                      <br>입력한 쿠폰번호 우측의<br>[등록] 버튼을 눌러주세요
                    </div>
                  `

          this.$Alert.customGrayAlert(msg, true, '확인',true).then(res => {
              const eventDiv = document.getElementById('eventDiv')
			  if (eventDiv) {
			      const trgtHeight = eventDiv.offsetTop
			      window.scrollTo(0, trgtHeight)
		      }
          })
        return
      }
	
  	  // 1. 예금주 정보 확인
      const bankObj1 = this.bankCdList.find(
        c => c.cmnsCd === this.params.bankCd
      )
      const passYn = this.getPassYn
      if ("Y" === passYn) {

        if (this.isNotEmpty(bankObj1 ? bankObj1.cmnsCd : '') && this.isNotEmpty(this.params.cstmAccnNum) && this.isNotEmpty(this.params.cstmNm)) {
          const AccnInfoParams = {
            bankCd: bankObj1.cmnsCd,
            cstmAccnNum: this.params.cstmAccnNum,
            cstmNm: this.params.cstmNm
          }

          var rsltCstmNm = ""
          var rsltMsg = "예금주명 조회중 오류가 발생했습니다"
          const accnOwnrInqrRes = await this.$http.post('/api/purchase/public/bank/isMatchAccnInfoDetail', AccnInfoParams)
          if (accnOwnrInqrRes) {
            const { data: { status, result } } = accnOwnrInqrRes
            if (status === '200' && this.isNotEmpty(result) ) {
              rsltCstmNm = result.rsltCstmNm
              rsltMsg = result.rsltMsg
            }
          }

          if ( rsltCstmNm == undefined || rsltCstmNm == "" ) {
            this.$Alert.alert(rsltMsg)
            return
          }

          const confirmAccount = await this.$Alert.confirm("예금주 : "+rsltCstmNm+"<br/>"
            +"은행명 : "+bankObj1.cmnsCdNm+"<br/>"
            +"계좌번호 : "+this.params.cstmAccnNum+"<br/>이체를 진행하시겠습니까?")

          if (!confirmAccount) {
            return
          } else {
            this.params.cstmNm = rsltCstmNm
          }

        } else {
          this.$Alert.alert('계좌정보를 입력해주세요')
          return
        }

      } else if ("N" === passYn) {
        this.$Alert.alert('PASS 인증을 진행해주세요')
        return
      } else if (this.isForeigner) {
        this.$Alert.alert('PASS 인증을 진행해주세요')
        return
      } else {

       
      } 
      
      let msg = `
        <h3>전자랜드 포인트 적립안내</h3>
        <div style="font-size: 14px; font-weight: 400; line-height:18px;">
          <br>포인트를 적립하시려면 <br>아래 '동의'버튼을 선택해 주세요
          <br>미동의 시 포인트는 적립되지 않습니다
        </div>
      `
      
      if (this.isEtland) {
      	if(!this.agrms.etlandAgrm) {
      		const confirmEtland = await this.$Alert.customSelect(msg, true,'미동의','동의')
            if (!confirmEtland) {
            	this.agrms.etlandAgrm = true
          } 
      	}
      }
      

      // 2. 계좌 등록 처리
      const bankObj = this.bankCdList.filter(obj => obj.cmnsCd === this.params.bankCd)
	  
	  if(this.isAllDonate) {
	      const dntnUpdateRes = await this.$http.post('/api/purchase/public/donate/save', {
	        ordNum: this.getOrderNumber,
	        dntnCstmNm: this.dntnParams.dntnCstmNm,
	        dntnCstmIdntNum: this.dntnParams.dntnCstmIdntNum,
	        partDntnAmt: this.partDntnAmt,
	        thrdptyAgrmCd: this.agrms.etlandAgrm == true ? '001':'',
	        chocAgrm: this.agrms.chocAgrm == true ? 'Y':'N'
	      })
	      if (dntnUpdateRes) {
	        const { data: { status, result } } = dntnUpdateRes
	        
	        this.$Alert.alert(this.donateResponse[result]).then(() => {
	          this.closeWindow()
	          this.$router.go(0)
	        })
	      }
      }
      
      if(!this.isAllDonate) {
	    if ("Y" !== passYn) {
	    	const accnOwnrInqrRes = await this.$http.post('/api/purchase/public/bank/isMatchAccnInfo', this.params)
	        let isMatch = false
	        if (accnOwnrInqrRes) {
	          const { data: { status, result } } = accnOwnrInqrRes
	
	          if (status === '200') {
	            isMatch = result.isMatch
	          }
	        }
	
	        if (!isMatch) {
	          this.$Alert.alert('인증 정보의 이름과 계좌정보의 이름이 같지 않습니다')
	
	          const eng = /^[a-zA-Z ]*$/
	          if (eng.test(this.params.cstmNm)) {
	            this.isForeigner = true
	          } 
	          return
	        }
        }
        const param = {
	        ord_number: this.getOrderNumber,
	        om_bank_name: bankObj[0].cmnsCdNm,
	        om_account: this.params.cstmAccnNum,
	        om_acc_name: this.params.cstmNm,
	        event_val: this.eventVal,
	        deposit_pass_yn: this.getPassYn,
	        dntnCstmNm: this.dntnParams.dntnCstmNm,
	        dntnCstmIdntNum: this.dntnParams.dntnCstmIdntNum,
	        partDntnAmt: this.partDntnAmt,
	        thrdptyAgrmCd: this.agrms.etlandAgrm == true ? '001':'',
	        chocAgrm: this.agrms.chocAgrm == true ? 'Y':'N'
	      }

        const bankinfoUpdateRes = await this.$http.put('/api/purchase/public/bank/order/bankinfo-update', param)
        if (bankinfoUpdateRes) {
          const { data: { status, result } } = bankinfoUpdateRes

          if (status === '200') {
            const { error_msg , dntn_error_msg } = result
            if (error_msg) {
              // 이벤트 코드 초기화
              this.temp_event = null
              await this.$nextTick()
              this.temp_event = ''

              this.eventVal = ''
              this.params.eventVal = ''
              //

              if(dntn_error_msg) {
                return this.$Alert.alert(this.donateResponse[dntn_error_msg])
              } else {
                if(error_msg === '이벤트 코드 또는 전화번호가 이벤트 대상이 아닙니다.'){
                  let msg = `
                    <h3>쿠폰을 등록할 수 없어요!</h3>
                    <div style="font-size: 14px; font-weight: 400; line-height:18px; margin-bottom: 10px;">
                      <br>참여 조건을 다시 한 번 확인해 주세요
                    </div>
                    <div style="font-size: 12px; font-weight: 400;">
                      ※ '계속 진행할게요' 선택 시 계좌번호가<br>제출되며 쿠폰은 다시 등록할 수 없어요
                    </div>
                  `

                  this.$Alert.customSelect(msg,true,'다시 등록하기','계속 진행할게요')
                  .then(res => {
                    if (!res) {
                      this.isEventChecked = false;
                      return this.handleEnrollmentButtnClick()
                    }
                  })
                } else {
                  return this.$Alert.alert(error_msg)
                }
              }
              
            } else {
              this.$Alert.alert('등록되었습니다').then(() => {
              this.closeWindow()
              this.$router.go(0)
            })
            }
          }
        }

      }
    },

    validation( t , a , b) {
    	this.valid = t;
    	this.txtBox = a;
    	this.txtBox2 = b;
    },
    validation2( t , a) {
    	this.valid2 = t;
    	this.txtBox3 = a;
    },
    validation3( t , a) {
    	this.valid3 = t;
    	this.txtBox4 = a;
    },
    validation4( t , a) {
    	this.valid4 = t;
    	this.txtBox5 = a;
    },
    async certPass() {
      this.certParams.ordNumber = this.getOrderNumber
      const rtn = await this.$http
        .post('/api/purchase/public/nice/cert/foreigner', {...this.$route.query, ...this.certParams})
        .then(res => {
          if (res.data && res.data.result) {
            const rs = res.data.result;
            console.log(rs);
            if ('success' === rs.msg) {
              const param = {};
              let tmpStrs = [];
              console.log(rs.cert_pass_url)
              if (rs.cert_pass_url) {
                if (rs.cert_pass_url.indexOf('?') > 0) {
                  const k = rs.cert_pass_url.substring(rs.cert_pass_url.indexOf('?') + 1).split('&');
                  for (let i in k) {
                    tmpStrs = k[i].split('=');
                    param[tmpStrs[0]] = tmpStrs[1]
                  }
                }
              }
              this.$router.push({name: 'CrtfPass', query: {...this.$route.query, ...param}})
            }
          }
        });
    },
    isNotEmpty(value) {
      return value !== undefined && value !== null && value !== '';
    },
    changeDonate(item) { 
    	this.isDonate = item.isDonate;
    	this.partDntnAmt = item.dntnAmt;
    },
    changeAllDonate(item) {
    	this.isAllDonate = item.isAllDonate;
    	this.partDntnAmt = item.dntnAmt;
    },changeDntnIdntNm(item) { 
    	this.dntnParams.dntnCstmNm = item.dntnCstmNm;
    	this.dntnParams.dntnCstmIdntNum = item.dntnCstmIdntNum;
    },
    
  }
}
</script>

<style>
#toggle_cont {
  font-size: 0.8125rem;
  color: #2a2a2a;
  position: relative;
  display: inline-block;
  line-height: 25px;
}
#toggle_cont::after {
  content: "\E942";
  font-family: "xeicon";
  color: #2a2a2a;
  position: absolute;
  right: 0px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 1.125rem;
  font-weight: 600;
}
.slide-up {
  transition: all 0.25s;
}
.slide-up-enter-active {
  transition: all 0.25s ease;
}
.slide-up-leave-active {
  transition: all 0.25s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-up-enter,
.slide-up-leave-active {
  opacity: 0;
  transform: translateY(100%);
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/sale/TalkDeposit_new.vue